/**
 * CR422: Config Source Debug Chip
 * 
 * Admin-only indicator showing where the deal card config was loaded from.
 * Displays: SSOT vs Legacy, environment, version ID, deal type.
 */

import type { SpecSource } from "@/lib/deal-cards/specV2/loadSpec";

interface ConfigSourceChipProps {
  source: SpecSource | null;
  className?: string;
}

export function ConfigSourceChip({ source, className = "" }: ConfigSourceChipProps) {
  if (!source) return null;

  const isSSOT = source.type === "ssot";
  const bgClass = isSSOT
    ? "bg-emerald-900/60 text-emerald-300 border-emerald-700/50"
    : source.type === "legacy"
      ? "bg-amber-900/60 text-amber-300 border-amber-700/50"
      : "bg-slate-800/60 text-slate-400 border-slate-600/50";

  return (
    <div
      className={`inline-flex items-center gap-1.5 text-[10px] font-mono px-2 py-0.5 rounded border ${bgClass} ${className}`}
    >
      <span className="font-semibold">
        {isSSOT ? "SSOT" : source.type === "legacy" ? "LEGACY" : "FALLBACK"}
      </span>
      {source.environment && (
        <>
          <span className="opacity-50">·</span>
          <span>{source.environment}</span>
        </>
      )}
      <span className="opacity-50">·</span>
      <span>{source.dealType}</span>
      {source.versionShort && (
        <>
          <span className="opacity-50">·</span>
          <span>v={source.versionShort}</span>
        </>
      )}
    </div>
  );
}
